import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Skeleton компонент для строки таблицы
const TableRowSkeleton = () => (
  <div className="grid grid-cols-4 gap-4 items-center border-b py-2 animate-pulse">
    <div className="flex items-center gap-2">
      <div className="w-6 h-6 bg-gray-300 rounded"></div>
      <div className="h-4 bg-gray-300 rounded w-32"></div>
    </div>
    <div className="h-4 bg-gray-300 rounded w-20"></div>
    <div className="h-4 bg-gray-300 rounded w-16"></div>
    <div className="h-8 bg-gray-300 rounded w-24"></div>
  </div>
);

function AllTeam() {
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchf() {
      setLoading(true);
      try {
        const res = await fetch("https://time-api.web-hub.online/api/teams");
        const data = await res.json();
        console.log("Notion block data:", data);
        setTeams(data?.results || []);
      } catch (error) {
        console.error("Error fetching teams:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchf();
  }, []);

  return (
    <div className="w-full max-w-[1480px] bg-white rounded-lg shadow-lg p-8">
      <div className="mb-6 text-3xl font-bold">All Teams</div>
      
      <div className="overflow-x-auto">
        <div className="min-w-full">
          <div className="grid grid-cols-4 gap-4 font-bold border-b pb-2 mb-4">
            <div>Team Member</div>
            <div>Role</div>
            <div>Projects Count</div>
            <div>Actions</div>
          </div>

          {loading ? (
            // Skeleton loader
            <>
              <TableRowSkeleton />
              <TableRowSkeleton />
              <TableRowSkeleton />
              <TableRowSkeleton />
              <TableRowSkeleton />
            </>
          ) : (
            // Реальные данные
            teams.sort((a) => a.properties?.['Должность']?.rich_text?.[0]?.plain_text.includes('-') ? 1 : -1).map((team) => {
              const name = team.properties?.Name?.title?.[0]?.plain_text || 'Unnamed Member';
              const projectsCount = team.properties?.['🧾 Проекты']?.relation?.length || 0;
              const role = team.properties?.['Должность']?.rich_text?.[0]?.plain_text.replace(/\n/g, ' | ') || 'No role specified';

              return (
                <div key={team.id} className="grid grid-cols-4 gap-4 items-center border-b py-2">
                  <div className="flex items-center gap-2">
                    {team.icon?.emoji && <span className="text-xl">{team.icon.emoji}</span>}
                    <span>{name}</span>
                  </div>
                  <div>{role}</div>
                  <div>{projectsCount} projects</div>
                  <div>
                    <Link
                      to={`/developers/${team.id}`}
                      className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors"
                    >
                      Go to Workspace
                    </Link>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
}

export default AllTeam;
